import {ArrowPathIcon} from '@heroicons/react/24/outline'
import Switch from '../../../../../../components/general/Switch.tsx'
import {cn} from '../../../../../../lib/utils.ts'
import {fieldLabelClasses} from '../../../../../../components/general/fieldStyles.ts'
import {
    CADENCE_LABELS,
    CADENCE_ORDER,
    formatDateNL,
    nextOccurrenceAfterInvoiceDate,
} from '../../RecurringInvoicesPage/utils/recurringInvoiceFormat.ts'
import type {RecurringCadence} from "../../../../../../generated/enums.ts";

type Props = {
    enabled: boolean
    cadence: RecurringCadence
    invoiceDateISO: string
    onToggle: (enabled: boolean) => void
    onCadenceChange: (cadence: RecurringCadence) => void
    disabledReason?: string
}

export function RecurringInvoiceCard({
    enabled,
    cadence,
    invoiceDateISO,
    onToggle,
    onCadenceChange,
    disabledReason,
}: Props) {
    const isLocked = disabledReason !== undefined
    const nextInvoiceDate = nextOccurrenceAfterInvoiceDate(invoiceDateISO, cadence)

    return (
        <div className="rounded-lg border border-gray-200">
            <div className="flex items-center justify-between gap-4 p-4">
                <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-superliteprimary">
                        <ArrowPathIcon className="h-5 w-5 text-primary"/>
                    </div>
                    <div>
                        <span className="text-sm font-semibold text-gray-900">Terugkerende factuur</span>
                        <p className="mt-0.5 text-xs text-gray-600">
                            Verstuur deze factuur automatisch op een vast ritme.
                        </p>
                    </div>
                </div>
                <Switch
                    checked={enabled}
                    disabled={isLocked}
                    onChange={onToggle}
                    aria-label="Terugkerende factuur"
                />
            </div>

            {isLocked && (
                <div className="border-t border-gray-200 px-4 py-3">
                    <p className="text-xs text-gray-500">{disabledReason}</p>
                </div>
            )}

            {enabled && !isLocked && (
                <div className="border-t border-gray-200 p-4">
                    <label className={cn(fieldLabelClasses, "mb-2 block")}>Herhaal elke</label>
                    <div className="flex flex-wrap gap-2">
                        {CADENCE_ORDER.map((option) => (
                            <button
                                key={option}
                                type="button"
                                onClick={() => onCadenceChange(option)}
                                aria-pressed={option === cadence}
                                className={cn(
                                    "rounded-full border px-4 py-1.5 text-sm transition-colors",
                                    option === cadence
                                        ? "border-primary bg-primary text-white"
                                        : "border-gray-300 text-gray-700 hover:bg-gray-50",
                                )}
                            >
                                {CADENCE_LABELS[option]}
                            </button>
                        ))}
                    </div>
                    <p className="mt-3 text-sm text-gray-600">
                        Volgende factuur wordt automatisch aangemaakt en verstuurd
                        op <span className="font-semibold text-gray-900">{formatDateNL(nextInvoiceDate)}</span>.
                    </p>
                </div>
            )}
        </div>
    )
}
